import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const RequiredField = props => {
  const { required, isEmpty, formikError } = props;

  return (
    <div style={{ display: 'inline' }}>
      &nbsp;
      { (required && isEmpty) || formikError
        ? <p style={{ display: 'inline', color: 'red' }}>*</p>
        : <FontAwesomeIcon
          icon={['fas', 'check']}
          color="green"
          size="xs"
        />
      }
    </div>
  );
};
